//#region INTERFACE ISmtpConfig
export interface ISmtpConfig {
  port: number;
  server: string;
  sslOnly: boolean;
}

//#endregion

//#region INTERFACE IImapConfig
export interface IImapConfig {
  port: number;
  sentBox: string;
  server: string;
  sslOnly: boolean;
}

//#endregion

//#region INTERFACE IEmailSettings
export interface IEmailSettings {
  email: string;
  imap: IImapConfig;
  pwd: string;
  smtp: ISmtpConfig;
  /**
   * `microsoft365` when that account is the sender.
   * `smtp`, or a missing value, is Standard.
   */
  authType?: string;
  /**
   * Mailbox address shown for Microsoft 365.
   * Kept off the Firestore write.
   */
  connectedMailbox?: string;
  enableImap?: boolean;
  encryptedPwd?: boolean;
  /**
   * True when Firestore has a Microsoft refresh token.
   * The token itself is never copied into app state.
   */
  hasMicrosoftRefreshToken?: boolean;
  /**
   * When the last email test finished.
   */
  lastTestAt?: string;
  /**
   * Account used for the last email test: `smtp` or `microsoft365`.
   */
  lastTestAuthType?: string;
  /**
   * Server message from the last failed email test.
   */
  lastTestMessage?: string;
  /**
   * `SENT` or `FAILED` for the last finished email test.
   */
  lastTestStatus?: string;
  /**
   * Firebase uid whose mailer document holds the Microsoft mailbox sign-in.
   */
  microsoftUserId?: string;
  status?: string;
  user?: string;
}

//#endregion